module.exports = __webpack_public_path__ + "img/Jallalla.ee72ef47.png";